import { generateUtilityClasses } from '@mui/material';

export const buttonClasses = generateUtilityClasses('Button', ['root', 'label']);
